// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminPortalUiSemantics = {
  uiSemanticsTitle: "UI Semantics Overview",
  uiSemanticsSubtitle: "Review shared admin action semantics, icons, and color mapping.",
  uiSemanticsNotice:
    "The same action intent should reuse the same semantic key so icon and token color stay consistent.",
  uiSemanticsTableTitle: "Semantic Mapping",
  uiSemanticsColumnSemantic: "Semantic",
  uiSemanticsColumnChineseLabel: "Chinese Label",
  uiSemanticsColumnIcon: "Icon",
  uiSemanticsColumnColor: "Color Token",
  uiSemanticsPreviewTitle: "AdminRowActions Preview",
  uiSemanticsLegendTitle: "Legend Semantic Mapping",
  uiSemanticsLegendColumnSemantic: "Legend Semantic",
  uiSemanticsLegendColumnDefaultLabel: "Default Label",
  uiSemanticsLegendColumnBadge: "Badge",
  uiSemanticsLegendColumnColor: "Standard Color Token",
  uiSemanticsLegendUndefined: "Undefined legend semantic: {value}",
} as const;
